<template>
    <div id="pay_success">
        <div class="top_title fixed">购买商品</div>
        <div class="success">
            <p>购买成功，请前往游戏通过邮件</p>
            <p>接受您的道具</p>
        </div>
        <el-button class="backMarket" type="primary" @click="backmarket">返回市场</el-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        backmarket() {
            this.$router.push({
                path: '/'
            })
        }
    },
}
</script>
<style lang="less" scoped>
    #pay_success {
        .success {
            margin: 8.8rem 0 21.2rem;
            p {
                text-align: center;
                font-size: 1.45rem;
                color: #999;
            }
        }
        .backMarket {
            display: block;
            margin: 0 auto;
            width: 13.5rem;
            height: 3.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10rem;
            font-size: 1.4rem;
        }
    }
</style>